import { TenantConfigResponse, TenantConfig } from './tenantConfigTypes';
import { TENANT } from './tenantConfigConstants';

export function parseTenantConfig(response: TenantConfigResponse): TenantConfig {
  const { tenant } = response;

  const result: TenantConfig = {};

  Object.entries(tenant).forEach(([namespace, configs]) => {
    Object.entries(configs).forEach(([configName, configValue]) => {
      result[`${TENANT}.${namespace}.${configName}`] = configValue.value;
    });
  });

  return result;
}
